import React, { useEffect } from 'react';


const PoliticaComercialPescaMX = () => {


    const discountData = [
        { from: "$0.00", to: "$9,999.00", discount: "0%" },
        { from: "$10,000.00", to: "$29,999.00", discount: "2%" },
        { from: "$30,000.00", to: "$59,999.00", discount: "4%" },
        { from: "$60,000.00", to: "$99,999.00", discount: "6%" },
        { from: "$100,000.00", to: "$299,999.00", discount: "8%" },
        { from: "$300,000.00", to: ">", discount: "12%" },
    ];

    return (



        <section className="fale-conosco container">
            <div className="sect-header">
                <div className="sect-titulo">
                    <h1>Política Comercial</h1>
                </div>
                <hr />
            </div>
            <div className="subtitulo-politics">
                <h4>Objetivo</h4>
                Este documento tiene como objetivo establecer las reglas básicas de Shimano México para definir la estrategia de
                comercialización. Esta política es fundamental para el correcto funcionamiento de la empresa ya que de ella dependerán
                directamente los resultados comerciales.
            </div>
            <div className="subtitulo-politics">
                <span>1. Términos de pago (plazo):</span><br /><br />
                Se tomará como base los históricos que cada cliente ha tenido con la marca Shimano. Quedando los plazos de pago de la
                siguiente manera:
                <ul>
                    <li><b>Pago de Contado:</b>  Este plazo aplica para nuevos clientes y para aquellos que no tengan un historial crediticio con
                        la marca.
                    </li>
                    <li><b>30 Días:</b>  Con base al histórico de la cuenta se tomará un periodo mínimo de tres meses y se realizará una evaluación, para
                        determinar si es acreedor a tener un financiamiento de treinta días.
                    </li>
                </ul>
                Los clientes con retraso de pago en sus facturas entrarán en un periodo de congelamiento de la cuenta para sus siguientes
                pedidos, una vez recibido el 100% del total del vencimiento se activará la cuenta. Adicional a lo anterior a partir del día 1 de
                retraso, se tendrá una multa equivalente al 5%mensual (prorrateado) del total de la deuda. Del mismo modo su límite de
                crédito será disminuido un 50% y deberá pasar un periodo de 3 meses para poder acceder a su límite de crédito inicial. Si
                el retraso es mayor a 8 semanas, se perderá el 100% del límite de crédito y el cliente pasará a un esquema de contado.

            </div>
            <div className="subtitulo-politics">
                <span>2. Límite de Crédito:</span><br /><br />
                Sin excepción, todos los clientes con derecho a plazo deberán ser previamente documentados con un pagare que respalde
                legalmente el valor de su crédito. Los clientes interesados en incrementar su límite de crédito tendrán que mostrar un
                histórico mínimo de 3 meses de pagos puntuales en tiempo para poder tener acceso a un incremento de 20% sobre su
                monto de crédito actual. Idealmente el cliente deberá presentar comprobantes de límite de crédito con otros proveedores y
                de ser posible sus estados financieros como soporte. Todos los incrementos de crédito deberán ser aprobados por Shimano
                México y en algunos casos puede no aplicar el incremento si la compañía así lo decide.

            </div>
            <div className="subtitulo-politics">
                <span>3. Monederos:</span><br /><br />
                Clientes con línea de crédito. Una vez liquidada la factura antes de su vencimiento se obtendrá el 1% de
                bonificación en un monedero electrónico, el cual tendrá vigencia y deberá utilizarse antes de cerrar el año en curso.

            </div>
            <div className="subtitulo-politics">
                <span>4. Canales de Distribución:</span><br /><br />
                Los canales de distribución establecidos son los enlistados a continuación. Por estrategia no está permitida la venta a otros
                canales que no estén enlistados:<br /><br />
                <ul>
                    <li><b>Tienda de Pesca Especializada</b>: Tiendas que se dedican a la pesca deportiva y manejan diferentes marcas.</li>
                    <li><b>Caza y Pesca</b>: Tiendas que manejan productos de cacería, tiro con arco, artículos de campismo y pesca deportiva.</li>
                    <li><b>Ferretería Marítima</b>: Tiendas con herramientas, refacciones marítimas y pesca deportiva.</li>
                    <li><b>Tiendas Departamentales</b>: Con departamentos especializados en deportes.</li>
                    <li><b>Embarcaciones y Pesca</b>: Especializadas en embarcaciones, motores y equipos para pesca deportiva.</li>
                    <li><b>Tiendas de Deportes</b>: Especializadas en 2 o 3 deportes diferentes incluyendo pesca deportiva.</li>
                    <li><b>Turismo</b>: Especialistas en promover la pesca y que cuenten con tienda propia.</li>
                    <li><b>Pesca Comercial y Deportiva</b>: Tiendas de pesca, venta de redes y arpón, que tengan venta de pesca deportiva.</li>
                    <li><b>Mayorista</b>: Clientes con almacenes o tiendas propias que se dedican a comercializar la marca.</li>
                    <li><b>Talleres de Pesca</b>: Establecimientos dedicados al mantenimiento de equipos de pesca.</li>
                    <li><b>Pet Shop</b>: Tiendas que manejan productos para mascotas con una sección de pesca deportiva.</li>
                    <li><b>E- Commerce</b>: Clientes cuyo modelo de negocio es on-line pero tambien con tienda física.</li>

                </ul>
            </div>

            <div className="subtitulo-politics">
                <span>5. Descuentos:</span><br /><br />

                Shimano México tendrá revisiones trimestrales de facturación para ajustes de descuento con base al histórico que se
                determinará en el promedio mensual.

                <div style={{ padding: '20px', maxWidth: '600px', margin: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th colSpan="3" style={{ ...thStyle, textAlign: 'center', backgroundColor: '#e0e0e0' }}>
                                    DESCUENTO BASADO EN PROMEDIO MENSUAL DE COMPRA
                                </th>
                            </tr>
                            <tr>
                                <th style={thStyle}>DE</th>
                                <th style={thStyle}>PARA</th>
                                <th style={thStyle}>% DESCUENTO</th>
                            </tr>
                        </thead>
                        <tbody>
                            {discountData.map((row, index) => (
                                <tr key={index}>
                                    <td style={tdStyle}>{row.from}</td>
                                    <td style={tdStyle}>{row.to}</td>
                                    <td style={tdStyle}>{row.discount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                Se obtendrá el <b>3%</b> de descuento adicional en pedidos que sean pagados de contado, siempre y cuando el cliente
                tenga crédito.
            </div>
            <div className="subtitulo-politics">
                <span>Todos los descuentos deberán tener una previa autorización de la Gerencia Comercial.</span><br /><br />
                Estos descuentos serán otorgados con base en el histórico de compra mensual. Se tendrá una revisión trimestral del monto
                facturado para tomar decisiones de incremento o decremento de estos.
            </div>

            <div className="subtitulo-politics">
                <span>6. Pagaré y Buró de Crédito</span><br /><br />
                Para la autorización del crédito, se deberá firmar un pagare, así como el documento de autorización de consulta en Buró de
                crédito.
            </div>


            <div className="subtitulo-politics">
                <span>7. Mínimo de Compra y Envíos</span><br /><br />
                El mínimo de compra será de $2,000.00 + IVA MXN con un costo de envío de $200.00 + IVA MXN. El monto mínimo de
                pedido para ser acreedor al envió gratis será de $5,000.00 + IVA MXN
            </div>

            <div className="subtitulo-politics">
                <span>8. Documentos y Datos para alta</span><br /><br />
                <ul>
                    <span>Documentos</span><br />

                    <li>Acta Constitutiva (en caso de ser persona moral), identificación oficial por ambos lados del representante legal,
                        constancia de situación fiscal actualizada, comprobante de domicilio fiscal no mayor a tres meses, política comercial
                        firmada por el representante legal</li>

                    <span>Datos</span><br />

                    <li>Nombre de la razón social ya sea física o moral, uso de CFDI, teléfono de contacto, nombre del contacto(s),
                        dirección de entrega.</li></ul>
            </div>

            <div className="subtitulo-politics">
                <span>9. Métodos de Pago</span><br /><br />
                Todas las facturas deberán ser liquidadas vía transferencia electrónica o deposito en ventanilla a nuestra cuenta, <b>no se
                    aceptan pagos en efectivo o cheque</b>. Del mismo modo es <b>indispensable y riguroso</b> que en el número de referencia de
                la transferencia o depósito, se incluya el <b>número de factura o pedido</b> al cual refiere la transacción. De no incluir esta
                referencia, Shimano México no podrá asociar el pago a una factura o pedido y no se podrá identificar.
            </div>

            <div className="subtitulo-politics">
                <span>10. Facturación</span><br /><br />
                Shimano México no garantiza que los pedidos ingresados o pagados (en el caso de los pedidos de contado los cuales
                deben ser pagados anticipadamente previo a su facturación y envió) sean facturados dentro del mismo mes en curso.
                Lógicamente siempre se tratará de facturar y enviar los pedidos dentro del mismo mes en el que son recibidos, sin embargo,
                en los <b>últimos 3 días del mes</b> debido a la carga de pedidos no garantizamos esto pueda ser siempre posible.
            </div>

            <div className="subtitulo-politics">
                <span>11. Exclusividad sobre distribución:</span><br /><br />
                Shimano México no garantiza la exclusividad en la distribución de los productos por zona que adquiera directamente con la
                marca en el instante que son dados de alta con la compañía.
            </div>

            <div className="subtitulo-politics" style={{ fontWeight: 'bold' }}>
                Todos los clientes deberán conocer sus condiciones comerciales por escrito. Por lo tanto, es necesario que todos nuestros
                clientes entiendan y firmen las políticas comerciales.
            </div>
        </section >
    );
};

const thStyle = {
    border: '1px solid #ccc',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    textAlign: 'center',
};

const tdStyle = {
    border: '1px solid #ccc',
    padding: '10px',
    textAlign: 'center',
};

export default PoliticaComercialPescaMX;


